import { render, staticRenderFns } from "./edit-room-dialog.vue?vue&type=template&id=08c9e9cc&"
import script from "./edit-room-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-room-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports